import type { Company } from '@gat-ship/types'

/**
 * Active vs inactive company counts for the companies panel's Active/Inactive
 * switcher (it only shows while inactive companies exist).
 */
export function countCompaniesByStatus(companies: readonly Company[]): {
  active: number
  inactive: number
} {
  return {
    active: companies.filter((company) => !company.isInactive).length,
    inactive: companies.filter((company) => company.isInactive).length
  }
}

/**
 * The Active/Inactive switcher only shows while there are inactive companies.
 * When the last inactive company is reactivated the switcher disappears, so fall
 * back to the active list instead of leaving the view stuck on the now-empty
 * inactive filter (matches the retired routed view's default tab).
 */
export function resolveEffectiveTab(
  activeTab: string,
  inactiveCount: number
): string {
  return inactiveCount === 0 ? 'active' : activeTab
}
